export default "__VITE_ASSET__D8pb1YFR__"